import React from "react";
import { Typography } from "@mui/material";

interface IRequiredFieldMarkProps {
  disabled?: boolean;
}

export const RequiredFieldMark: React.FC<IRequiredFieldMarkProps> = ({
  disabled,
}) => {
  return (
    <Typography component="span" color={disabled ? "action.disabled" : "error"}>
      *
    </Typography>
  );
};
